import { createFileRoute } from "@tanstack/react-router";

import { PermissionGuard } from "@/components/shared/guards/permission-guard";
import { BaaPreflightPage } from "@/features/baa-preflight";

export const Route = createFileRoute("/baa-preflight/")({
  component: () => (
    <PermissionGuard module="baa_preflight">
      <BaaPreflightPage />
    </PermissionGuard>
  ),
});
